import { axiosApi } from "../../../../../../../api/dbAxios";

export const updateTeamSummary = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
  id: string,
  summary: string,
) => {
  const test_email = "ykozak@deloittece.com";
  const body = {
    id: id,
    summary: summary,
  };
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";

    const response = await axiosApi.post(
      `/items/${regulatorCode}/${case_no}/team_summary/`,
      isLocalhost ? { test_email, ...body } : body,
      {
        params: isLocalhost ? { test_email } : {},
      },
    );

    return response.data.summary;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      console.warn("403 Forbidden");
      throw new Error(error.response.data.detail);
    }
    throw error;
  }
};
